import { analytics } from '../analytics';
import { generateRandomIPAddress } from '../utils';

export enum REPORTING_ACCOUNT_ACTIVATION_STEP {
  REGISTER_FOR_ACCOUNT = 'Register for Account',
  SEND_EMAIL = 'Send Email',
  EMAIL_MAGIC_LINK_CLICK = 'Email Magic Link Click',
}

export enum ACCOUNT_ACTIVATION_SOURCE {
  APP = 'app',
  USER_PORTAL = 'user_portal',
}

import { REPORTING_EVENT_IDS } from '../events';

interface TrackAccountActivationProperties {
  organisation_id?: string;
  step_description: REPORTING_ACCOUNT_ACTIVATION_STEP;
  source: ACCOUNT_ACTIVATION_SOURCE;
}

export const trackAccountActivation = (
  properties: TrackAccountActivationProperties,
) => {
  return analytics.track(
    REPORTING_EVENT_IDS.REPORTER_PORTAL_ACCOUNT_ACTIVATION_STEP_CHANGED,
    properties,
    {
      context: { ip: generateRandomIPAddress() },
    },
  );
};

export const trackSlackAccountConnectionStepCompleted = (properties: {
  organisation_id: string;
  user_id: string;
  step_description:
    | 'login'
    | 'accept_terms'
    | 'connect_account_success'
    | 'connect_account_failure';
  first_time_connecting: boolean;
}) => {
  return analytics.track(
    REPORTING_EVENT_IDS.SLACK_ACCOUNT_CONNECTION_STEP_COMPLETED,
    properties,
    {
      context: { ip: generateRandomIPAddress() },
    },
  );
};
